export default "__VITE_ASSET__c58917a6__"